import React, { CSSProperties, FunctionComponent } from "react";
import WizardStep from "../WizardStep";
import statusJewellery from "../../../images/Progress/progress_schmuck.svg";
import { Box, makeStyles } from "@material-ui/core";
import GradienBoderButton from "../../../commonComponents/GradientButton";
import useMaterials from "../../state/hooks/materialHook";
import { Step } from "../../WizardMap";
import { Material } from "../../../API";
import {NavigationProps} from "../../slideRouter/navigationHook";

const useStyles = makeStyles(() => ({
    jewelleryContainer: {
        display: "flex",
        flex: 1,
        flexDirection: "column"
    }
}));

const StepJewelleryMaterial: FunctionComponent<NavigationProps> = ({ gotoNextSlide, gotoPrevSlide }) => {

    const { toggleMaterial, materialPresent, materialsToStore, materialIsEmpty } = useMaterials();

    const handleNextClick = (): void => {
        materialsToStore();
        gotoNextSlide(Step.ADD_INFO);
    };

    const classes = useStyles();

    const spacing: CSSProperties = { marginBottom: 15 };

    return (
        <WizardStep
            title={"Um welches Material handelt es sich?"}
            description={"Mehrfachauswahl möglich."}
            icon={statusJewellery}
            backButton={true}
            nextButton={true}
            nextButtonDisabled={materialIsEmpty()}
            onNextClick={handleNextClick}
            onBackClick={gotoPrevSlide}
        >
            <Box className={classes.jewelleryContainer}>
                <GradienBoderButton
                    text={"Gold"}
                    isChecked={materialPresent(Material.GOLD)}
                    onClick={() => toggleMaterial(Material.GOLD)}
                    style={spacing}
                />
                <GradienBoderButton
                    text={"Silber"}
                    isChecked={materialPresent(Material.SILVER)}
                    onClick={() => toggleMaterial(Material.SILVER)}
                    style={spacing}
                />
                <GradienBoderButton
                    text={"Platin"}
                    isChecked={materialPresent(Material.PLATIN)}
                    onClick={() => toggleMaterial(Material.PLATIN)}
                    style={spacing}
                />
                <GradienBoderButton
                    text={"Modeschmuck"}
                    isChecked={materialPresent(Material.FASHION)}
                    onClick={() => toggleMaterial(Material.FASHION)}
                    style={spacing}
                />
                <GradienBoderButton
                    text={"Unbekannt / Sonstiges"}
                    isChecked={materialPresent(Material.UNKNOWN_DIFFERENT)}
                    onClick={() => toggleMaterial(Material.UNKNOWN_DIFFERENT)}
                />
            </Box>
        </WizardStep>
    );
};

export default StepJewelleryMaterial;
